var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider js_slider"},[_c('div',{staticClass:"frame js_frame"},[_c('ul',{staticClass:"slides js_slides"},[_vm._t("default")],2)]),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }